<div class="pageWrapper">
  <div
    [style.display]="!loader ? 'none' : 'flex'"
    style="width: 100%; height: 100vh"
    class="center-div"
  >
    <mat-spinner></mat-spinner>
  </div>

  <div [style.display]="loader ? 'none' : 'block'">
    <div
      *ngIf="errorMessage"
      class="emptyTable"
      style="width: 100%; height: 400px; text-align: center"
    >
      {{ errorMessage }}
    </div>

    <div *ngIf="!errorMessage" class="divHome">
      <div class="row">
        <h1>Ticketería</h1>
      </div>
      <div
        style="
          border-radius: 12px;
          border: 1px solid rgb(255, 255, 255);
          padding: 0px 30px;
          gap: 30px;
        "
        class="center-div column-base"
      >
        <div class="row align-space-between" style="width: 100%">
          <div class="container-column col-lg-4">
            <mat-label class="label"> {{ "." }}</mat-label>
            <mat-form-field floatLabel="never" class="w-100 miBoton">
              <input
                matInput
                [(ngModel)]="searchValue"
                placeholder="Buscar"
                (ngModelChange)="applyFilterSelect(true)"
              />
              <mat-icon matSuffix>
                <i-tabler name="search" class="icon-20"></i-tabler>
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="row center-div col-lg-8" style="flex-wrap: wrap">
            <div class="container-column col-lg-3">
              <mat-label class="label">Mes de Operación </mat-label>

              <app-date-month-picker
                [value]="selectFechaOperacion"
                (valueChange)="handleFechaOperacionChange($event)"
              ></app-date-month-picker>
            </div>
            <div class="container-column col-lg-3">
              <mat-label class="label">Fecha de Generación de OS</mat-label>
              <mat-form-field
                floatLabel="never"
                class="w-100 miBoton"
                style="height: 100% !important"
              >
                <input
                  class="miDateInput"
                  matInput
                  [matDatepicker]="dp2"
                  [(ngModel)]="selectFechaGeneracionOS"
                  [matDatepickerFilter]="validarFecha"
                  placeholder="Dia/Mes/Año"
                  (ngModelChange)="applyFilterSelect(true)"
                />

                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dp2"
                ></mat-datepicker-toggle>
                <button
                  *ngIf="selectFechaGeneracionOS !== null"
                  mat-icon-button
                  matSuffix
                  aria-label="Resetear fecha"
                  (click)="resetFechaPago('selectFechaGeneracionOS')"
                >
                  <mat-icon>
                    <i-tabler name="X" class="icon-20 d-flex"></i-tabler>
                  </mat-icon>
                </button>
                <mat-datepicker #dp2></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="container-column col-lg-3">
              <mat-label class="label">Servicio / Ruta </mat-label>
              <mat-form-field
                floatLabel="never"
                class="w-100 miBoton"
                placeholder="Seleccionar"
              >
                <mat-select
                  [(value)]="selectServicio"
                  (selectionChange)="applyFilterSelect(true)"
                >
                  <mat-option value="{{ '' }}">Todos</mat-option>
                  <mat-option
                    *ngFor="let servicio of arrayServicios"
                    value="{{ servicio }}"
                    >{{ servicio }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div class="container-column col-lg-3">
              <mat-label class="label">Estado del Servicio</mat-label>
              <mat-form-field
                floatLabel="never"
                class="w-100 miBoton"
                placeholder="Seleccionar"
              >
                <mat-select
                  [(value)]="selectEstado"
                  (selectionChange)="applyFilterSelect(true)"
                >
                  <mat-option value="{{ '' }}">Todos</mat-option>
                  <mat-option
                    *ngFor="let Estado of arrayEstados"
                    value="{{ Estado }}"
                    >{{ Estado }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row-base div-between" style="gap: 20px; width: 100%">
          <div class="row-base" style="gap: 20px">
            <button
              *ngIf="!selectPendientes"
              (click)="handlePendientes()"
              [disabled]="pendientes === 0"
              style="background-color: #fdc560"
              class="sub-filter-btn"
            >
              <i-tabler
                *ngIf="pendientes > 0"
                name="exclamation-circle"
                class="icon-24"
              ></i-tabler>

              <div *ngIf="pendientes !== 1">
                <div *ngIf="pendientes !== 0">
                  Tienes {{ pendientes }} Tickets Pendientes
                </div>
                <div *ngIf="pendientes === 0">No tienes Tickets pendientes</div>
              </div>
              <div *ngIf="pendientes === 1">
                Tienes {{ pendientes }} Ticket Pendiente
              </div>
            </button>
            <button
              *ngIf="selectPendientes"
              (click)="handlePendientes()"
              style="background-color: #ed7c49"
              class="sub-filter-btn"
            >
              <i-tabler name="arrow-back" class="icon-24"></i-tabler>
              <div>Ver todas las Transacciones</div>
            </button>

            <button
              *ngIf="!selectLastMinute"
              (click)="handleLastMinutes()"
              [disabled]="lastMinute === 0"
              style="background-color: #797c55"
              class="sub-filter-btn"
            >
              <i-tabler
                *ngIf="lastMinute > 0"
                name="eye"
                class="icon-24"
              ></i-tabler>
              <div *ngIf="lastMinute !== 1">
                <div *ngIf="lastMinute !== 0">
                  Ver {{ lastMinute }} Files Last Minute
                </div>
                <div *ngIf="lastMinute === 0">No tienes Files Last Minute</div>
              </div>
              <div *ngIf="lastMinute === 1">
                Ver {{ lastMinute }} File Last Minute
              </div>
            </button>
            <button
              *ngIf="selectLastMinute"
              (click)="handleLastMinutes()"
              style="background-color: #ed7c49"
              class="sub-filter-btn"
            >
              <i-tabler name="arrow-back" class="icon-24"></i-tabler>
              <div>Ver todas las Transacciones</div>
            </button>
          </div>
          <div>
            <button
              (click)="generarOS()"
              class="generarOS-btn"
              [disabled]="blockBotonGenerarOS()"
              [style.cursor]="blockBotonGenerarOS() ? 'not-allowed' : 'pointer'"
            >
              Generar OS
            </button>
          </div>
        </div>

        <div
          *ngIf="
            dataSource?.filteredData?.length === 0 &&
            !errorMessage &&
            !isLoadingMore
          "
          class="center-div"
          style="
            width: 100%;
            height: 400px;
            text-align: center;
            font-size: 12px;
            font-weight: 350;
            color: #808080;
          "
        >
          Lo sentimos. No tenemos datos para esta busqueda.
          <br />Por favor, intenta con otro valor.
        </div>

        <div class="filtering-indicator" *ngIf="isLoadingMore">
          <mat-progress-bar
            mode="indeterminate"
            color="accent"
          ></mat-progress-bar>
          <span>
            Cargando más servicios… {{ loadedCount }} cargados. Los filtros y la
            búsqueda se aplican sobre lo ya descargado.
          </span>
        </div>

        <div
          class="example-container-table mat-elevation-z100"
          [style.display]="
            dataSource.filteredData.length !== 0 ? 'block' : 'none'
          "
        >
          <table
            mat-table
            matSort
            (matSortChange)="onSort($event)"
            [dataSource]="dataSource"
            id="mi-tabla"
            multiTemplateDataRows
          >
            <ng-container matColumnDef="ssffproduct">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="column-70"
              >
                -
              </th>
              <td mat-cell *matCellDef="let element" class="column-70">
                <div
                  *ngIf="element.ssffproduct"
                  class="tag-ssff-base tag-ssff-active"
                >
                  SSFF
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="categoriaServicio">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-70"
              >
                Cat. de Servicio
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-70"
              >
                <div *ngIf="element.categoriaServicio === 'sin categoria'">
                  -
                </div>
                <div
                  *ngIf="element.categoriaServicio !== 'sin categoria'"
                  class="tag-ticket-base"
                  [ngClass]="{
                    'tag-ticket-tren': element.categoriaServicio === 'TREN',
                    'tag-ticket-Entrada': element.categoriaServicio !== 'TREN'
                  }"
                >
                  {{ capitalize(element.categoriaServicio) }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="fileNumber">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-70"
              >
                Nro. de File
              </th>
              <td mat-cell *matCellDef="let element" class="column-70">
                {{ element.file?.fileNumber | nullToDash }}
              </td>
            </ng-container>

            <ng-container matColumnDef="displayState">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-90"
              >
                Estado File
              </th>
              <td mat-cell *matCellDef="let element" class="column-90">
                {{ element.file?.displayState | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startDateService">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-70"
              >
                Fecha de Operación
              </th>
              <td mat-cell *matCellDef="let element" class="column-70">
                {{
                  element.startDateService
                    ? (element.startDateService
                      | customDate
                      | date: "dd MMM yyyy")
                    : "-"
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="providerSnapshot">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-120"
              >
                Proveedor
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-120"
              >
                {{ element.providerSnapshot?.nombre | nullToDash }}
              </td>
            </ng-container>

            <ng-container matColumnDef="paxQuantity">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-50"
              >
                Pax
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-50"
              >
                {{ element.paxQuantity | nullToDash }}
              </td>
            </ng-container>
            <ng-container matColumnDef="tcQuantity">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-50"
              >
                TC
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-50"
              >
                {{ element.tcQuantity | nullToDash }}
              </td>
            </ng-container>
            <ng-container matColumnDef="nombreServicio">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-120"
              >
                Servicio / Ruta
              </th>
              <td mat-cell *matCellDef="let element" class="column-120">
                {{ element.nombreServicio | nullToDash }}
              </td>
            </ng-container>
            <ng-container matColumnDef="circuitoTren">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-100"
              >
                Circuito / Tren
              </th>
              <td mat-cell *matCellDef="let element" class="column-100">
                {{ element.circuitoTren | nullToDash }}
              </td>
            </ng-container>
            <ng-container matColumnDef="varianteFrecuencia">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-120"
              >
                Variante / Frecuencia
              </th>
              <td mat-cell *matCellDef="let element" class="column-120">
                {{ element.varianteFrecuencia | nullToDash }}
              </td>
            </ng-container>

            <ng-container matColumnDef="horario">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-80"
              >
                Horario
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-80"
              >
                {{ element.horario | nullToDash }}
              </td>
            </ng-container>
            <ng-container matColumnDef="ticket">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-120"
              >
                Ticket
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-120"
              >
                <div *ngFor="let item of element.ticket" class="column-base">
                  <div>
                    {{ item.cantidad }} -
                    {{ item.tipo }}
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-90"
              >
                Total
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-90"
              >
                {{ element.total != null ? element.moneda : "" }}
                {{
                  element.total != null ? (element.total | formatNumber) : "-"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="incidentesPreOp">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-90"
              >
                Incidentes Pre-Operativos
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-90"
              >
                <div class="summary-value">
                  <ng-container
                    *ngIf="
                      element.file?.pendingPreOpIncidents != null;
                      else withoutPreOpIncident
                    "
                  >
                    <div
                      class="review-icon-container"
                      [class.review-icon-container--static]="!interactive"
                      (click)="interactive && openPreOperationalIncidents(element)"
                      style="justify-content: flex-start"
                    >
                      <ng-container
                        *ngIf="
                          element.file?.pendingPreOpIncidents === 0;
                          else hasPendingPreOpIncidents
                        "
                      >
                        <i-tabler
                          name="message-report"
                          class="icon-tabler-review icon-check"
                          matTooltip="Incidentes Pre Operativos Aprobados"
                          matTooltipPosition="above"
                        ></i-tabler>
                        <div class="review-badge">
                          <i-tabler
                            name="circle-check-filled"
                            matTooltip="Incidentes Pre Operativos Aprobados"
                            matTooltipPosition="above"
                            class="icon-tabler-check icon-check"
                          ></i-tabler>
                        </div>
                      </ng-container>
                      <ng-template #hasPendingPreOpIncidents>
                        <i-tabler
                          name="message-report"
                          matTooltip="Incidentes Pre Operativos Pendientes"
                          matTooltipPosition="above"
                          class="icon-tabler-review icon-resolved"
                        ></i-tabler>
                        <div class="review-badge badge-red">
                          {{ element.file?.pendingPreOpIncidents }}
                        </div>
                      </ng-template>
                    </div>
                  </ng-container>

                  <ng-template #withoutPreOpIncident>
                    <div
                      style="display: flex; gap: 8px"
                      *ngIf="interactive; else dashIncidents"
                    >
                      <button
                        mat-icon-button
                        type="button"
                        (click)="openPreOperationalIncidents(element)"
                      >
                        <i-tabler
                          name="message-report"
                          matTooltip="Sin Revisión de Programación"
                          matTooltipPosition="above"
                          class="icon-tabler-file icon-gray"
                        ></i-tabler>
                      </button>
                    </div>
                    <ng-template #dashIncidents>
                      <span>-</span>
                    </ng-template>
                  </ng-template>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="estadoServicioTickets">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-100"
              >
                Estado del Servicio
              </th>
              <td
                mat-cell
                *matCellDef="let element; let i = index"
                class="column-100"
              >
                <ng-container [ngSwitch]="element?.estadoServicioTickets">
                  <div
                    *ngSwitchCase="'RESERVADO'"
                    class="tag-estado tag-estado-serv-Reservado"
                  >
                    {{ estadoServicioTicketsLabel["RESERVADO"] }}
                  </div>
                  <div
                    *ngSwitchCase="'CREADO'"
                    class="tag-estado tag-estado-serv-Creado"
                  >
                    {{ estadoServicioTicketsLabel["CREADO"] }}
                  </div>
                  <div
                    *ngSwitchCase="'EN_PROCESO'"
                    class="tag-estado tag-estado-serv-En-Proceso"
                  >
                    {{ estadoServicioTicketsLabel["EN_PROCESO"] }}
                  </div>
                  <div
                    *ngSwitchCase="'NUEVA_ADICION'"
                    class="tag-estado tag-estado-serv-Nueva-Adicion"
                  >
                    {{ estadoServicioTicketsLabel["NUEVA_ADICION"] }}
                  </div>

                  <div *ngSwitchDefault>
                    {{ element?.estadoServicioTickets || "-" }}
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef class="column-50">
                &nbsp;
                <mat-checkbox
                  *ngIf="allSameFile() && ticketEstadoCreated()"
                  [checked]="selectMasivo"
                  (change)="updateCheck()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let element" class="column-50">
                <button
                  mat-icon-button
                  aria-label="expand row"
                  (click)="toggleExpand(element, $event)"
                >
                  <mat-icon *ngIf="!isExpanded(element)"
                    >keyboard_arrow_down</mat-icon
                  >
                  <mat-icon *ngIf="isExpanded(element)"
                    >keyboard_arrow_up</mat-icon
                  >
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <th
                mat-sort-header
                mat-header-cell
                *matHeaderCellDef
                class="column-90"
              ></th>
              <td
                mat-cell
                [ngClass]="
                  isExpanded(element) ? 'open-expand' : 'no-open-expand'
                "
                *matCellDef="let element"
                [attr.colspan]="columnsToDisplayWithExpand.length"
              >
                <div
                  *ngIf="isExpanded(element) && element.ticketsLoading"
                  class="div-vertical-center"
                  style="padding: 16px; gap: 12px"
                >
                  <mat-spinner [diameter]="28"></mat-spinner>
                  <span>Cargando tickets…</span>
                </div>
                <app-table-expand
                  *ngIf="
                    isExpanded(element) &&
                    element.ticketsLoaded &&
                    !element.ticketsLoading
                  "
                  [file]="element"
                  [data]="element.tickets"
                  (selectionChange)="onSelectionChange($event)"
                  (changeDato)="onChangeDato($event)"
                  (onChangeDatosMasivos)="onChangeDatosMasivos($event)"
                  (ticketsOrderChanged)="onTicketsOrderChanged($event)"
                  [allData]="adaptedTicketServices"
                ></app-table-expand>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="columnsToDisplayWithExpand"
            ></tr>
            <tr
              mat-row
              *matRowDef="let element; columns: columnsToDisplayWithExpand"
              class="example-element-row"
              [class.example-expanded-row]="isExpanded(element)"
              (click)="toggleExpand(element)"
              [style.background-color]="
                hasInvalidTickets(element) ? '#ffebee' : ''
              "
            ></tr>
            <tr
              mat-row
              *matRowDef="let element; columns: ['expandedDetail']"
              class="example-detail-row"
            ></tr>
          </table>
        </div>

        <div *ngIf="showTotal()" class="div-end w-100">
          <div class="row-base total-container div-vertical-center">
            <div class="nombre">Total</div>
            <div class="monto">
              {{ this.signoByFileProveedor }}

              {{
                totalByFileProveedor != null
                  ? (totalByFileProveedor | formatNumber)
                  : "-"
              }}
            </div>
          </div>
        </div>

        <div
          style="width: 100%"
          [style.display]="
            dataSource.filteredData.length !== 0 ? 'block' : 'none'
          "
        >
          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100]"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
        <app-tickets-status-legend
          *ngIf="dataSource.filteredData.length !== 0"
        ></app-tickets-status-legend>
      </div>
    </div>
  </div>
</div>
